import React, { useEffect, useMemo, useState } from 'react';
import {
  getImagingTaskSourceLabel,
  getImagingTaskStateLabel,
  getFormatedDate,
  isNullOrUndefined,
} from 'utils/Global';
import './ImagingSchedule.scss';
import useRockFetchGet from 'utils/RockFetch';
import { useRMSelector } from 'redux/hooks';
import RMTable from 'components/customComponents/Controls/RMTable';
import { selectExp } from 'redux/selectors/ExperimentStateSelector';
import { useLastSelectedWellNavigationDetails } from 'redux/hooks/experiment';

export default function ImagingSchedule() {
  const [rockFetchGet] = useRockFetchGet();
  const [imagingSchedule, setImagingSchedule] = useState([]);
  const wellNavigationDetails = useLastSelectedWellNavigationDetails();
  const exp = useRMSelector(selectExp);

  const plate = useMemo(() => {
    if (!exp.plateDto) {
      return;
    }
    const plate = exp.plateDto.find((pl) => pl.plateId === wellNavigationDetails?.plateID);
    if (plate === null || plate === undefined) {
      return exp.plateDto[0];
    }
    return plate;
  }, [exp.plateDto, wellNavigationDetails?.plateID]);
  const columns = useMemo(
    () => [
      {
        Header: 'Date to Imaged',
        accessor: 'dateToImaged',
      },
      {
        Header: 'Date Imaged',
        accessor: 'dateImaged',
      },
      {
        Header: 'Status',
        accessor: 'state',
      },
      {
        Header: 'Source',
        accessor: 'source',
      },
    ],
    [],
  );
  useEffect(() => {
    async function fetchImagingSchedule() {
      const url = `api/imaging/imagingSchedule/${plate.plateId}`;
      let imgSchedule = await rockFetchGet(url);
      if (isNullOrUndefined(imgSchedule)) {
        return null;
      }
      if (!isNullOrUndefined(imgSchedule.status)) {
        imgSchedule = await imgSchedule.json();
      }
      const scheduleData = imgSchedule.map((schedule) => ({
        dateToImaged: getFormatedDate(schedule.dateToImaged),
        dateImaged: getFormatedDate(schedule.dateImaged),
        state: getImagingTaskStateLabel(schedule.state),
        source: getImagingTaskSourceLabel(schedule.source),
      }));
      setImagingSchedule(scheduleData);
    }
    fetchImagingSchedule();
  }, [plate]);

  return (
    <div id='commandpanel-imagingschedule-wrapper' className="imaging-table" style={{ height: '68vh' }}>
      <RMTable columns={columns} data={imagingSchedule} />
    </div>
  );
}
